import { useTranslation } from "react-i18next";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { useCurrencyDisplay } from "@providers/CurrencyDisplayProvider";

export type CurrencyMode = "account" | "global";

interface Props {
  accountCurrency?: string;
  value: CurrencyMode;
  onChange: (mode: CurrencyMode) => void;
}

export const CurrencyModeRadioGroup = ({
  accountCurrency,
  value,
  onChange,
}: Props) => {
  const { t } = useTranslation();
  const { globalCurrency, isLoading } = useCurrencyDisplay();

  if (
    isLoading ||
    !accountCurrency ||
    accountCurrency.toUpperCase() === globalCurrency.toUpperCase()
  ) {
    return null;
  }

  return (
    <RadioGroup
      data-testid="currency-mode-radio-group"
      value={value}
      onChange={(_, next) => onChange(next as CurrencyMode)}
    >
      <FormControlLabel
        value="global"
        control={<Radio data-testid="currency-mode-global" />}
        label={t("currencyMode.global", { currency: globalCurrency })}
      />
      <FormControlLabel
        value="account"
        control={<Radio data-testid="currency-mode-account" />}
        label={t("currencyMode.account")}
      />
    </RadioGroup>
  );
};
